import $ from 'jquery';

var _back = $('.js-back-to-top');
_back.on('click', function (){
    $("html, body").animate({scrollTop: 0}, 1000);
});

export function usefulBox(){

    $('.js-usefulBox').on('click', function (e){
        e.preventDefault();

        if( $(this).hasClass('active') ){
            $(this).removeClass('active');
            $('.usefulBox__body', this).slideUp();
        }else{
            $(this).addClass('active');
            $('.usefulBox__body', this).slideDown();
        }
    })

}
export function faqBox(){

    $('.js-faqBox').on('click', function (e){
        e.preventDefault();

        if( $(this).hasClass('opened') ){
            $(this).removeClass('opened');
            $('.announcementLink__body', this).slideUp();
        }else{
            $(this).addClass('opened');
            $('.announcementLink__body', this).slideDown();
        }
    })

}

// $('.js-scroll-links').on('click', function (e){
//     e.preventDefault();
//     $('html, body').animate({
//         scrollTop: $($.attr(this, 'href')).offset().top - 60
//     }, 1000);
// });